import React, { useState, useEffect } from "react";

const ScrollingMessage = () => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    const saved = localStorage.getItem("scrollingMessage");
    if (saved) {
      setMessage(saved);
    }
  }, []);

  const handleUpdate = (e) => {
    e.preventDefault();
    if (!message.trim()) {
      alert("Message cannot be empty.");
      return;
    }
    localStorage.setItem("scrollingMessage", message);
    alert("Scrolling message updated!");
  };

  return (
   <div className="container mt-4">
    <section className="content container-fluid mt-4">
      <section className="content">
        <div className="row">
          <div className="col-lg-10 col-md-10 col-sm-10 col-xs-12 col-lg-offset-1 col-md-offset-1 col-sm-offset-1">
            <div className="box box-primary">
              <div className="box-header with-border">
                <h3 className="box-title">
                  Scrolling Message 
                </h3>
              </div>

              <div className="box-body">
                <div className="row">
                  <div className="col-lg-10 col-md-10 col-sm-10 col-xs-12 col-lg-offset-2 col-md-offset-2 col-sm-offset-2">
                    <div className="form-group">
                      <textarea
                        className="form-control"
                        rows="10"
                        style={{ width: "100%" }}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Enter scrolling message... Use $ at end of each point"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12 col-lg-offset-2 col-md-offset-2 col-sm-offset-2">
                  <div className="form-group">
                    <button
                      className="form-control btn btn-primary btn-block"
                      onClick={handleUpdate}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
              {/* /.box-body */}
            </div>
          </div>
        </div>
      </section>
    </section>
    </div>
  );
};

export default ScrollingMessage;
